(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  function initialiseTbbBulkEnquiry() {
    const root = document.getElementById('corporate-enquiry');
    if (!root) return;
    const form = root.querySelector('form');
    const pendingKey = 'tbb_bulk_enquiry_pending_v1';
    const attributionKey = 'tbb_bulk_enquiry_attribution_v1';
    const read = key => {
      try { return JSON.parse(sessionStorage.getItem(key) || 'null'); }
      catch (_) { return null; }
    };
    const write = (key, value) => {
      try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {}
    };
    const params = new URLSearchParams(location.search);
    const attribution = read(attributionKey) || {};
    for (const key of ['utm_source', 'utm_campaign', 'utm_content']) {
      if (params.get(key)) attribution[key] = params.get(key).slice(0, 180);
    }
    write(attributionKey, attribution);
    if (form && !root.querySelector('[data-tbb-bulk-success]') && !form.dataset.tbbBulkBound) {
      form.dataset.tbbBulkBound = 'true';
      for (const input of form.querySelectorAll('[data-tbb-bulk-source]')) {
        input.value = attribution[input.dataset.tbbBulkSource] || 'direct / not captured';
      }
      const input = form.querySelector('[data-tbb-bulk-reference]');
      const ref = 'TBB-BULK-' + (globalThis.crypto?.randomUUID?.() || (Date.now().toString(36) + Math.random().toString(36).slice(2, 10)));
      if (input) input.value = ref;
      form.addEventListener('submit', () => {
        if (!form.checkValidity()) return;
        write(pendingKey, {id: input?.value || ref, at: Date.now()});
      });
    }
    if (!root.querySelector('[data-tbb-bulk-success]')) return;
    const pending = read(pendingKey);
    if (!pending?.id || Date.now() - pending.at > 3600000) return;
    const sent = read('tbb_bulk_enquiry_sent_v1') || {};
    const permitted = kind => {
      const privacy = window.Shopify?.customerPrivacy;
      const fn = kind === 'meta' ? privacy?.marketingAllowed : privacy?.analyticsProcessingAllowed;
      return typeof fn !== 'function' || fn.call(privacy);
    };
    const send = () => {
      if (!sent.meta && permitted('meta') && typeof window.fbq === 'function') {
        window.fbq('trackSingle', '345737026555009', 'Lead', {
          content_name: 'Diwali bulk gifting enquiry',
          content_category: 'Bulk gifting'
        }, {eventID: pending.id});
        sent.meta = true;
      }
      if (!sent.analytics && permitted('analytics') && typeof window.gtag === 'function') {
        window.gtag('event', 'generate_lead', {lead_type: 'bulk_gifting', event_id: pending.id});
        sent.analytics = true;
      }
      write('tbb_bulk_enquiry_sent_v1', {...sent, id: pending.id});
    };
    if (sent.id !== pending.id) { delete sent.meta; delete sent.analytics; }
    send();
    let attempts = 0;
    const timer = setInterval(() => {
      send();
      if (++attempts >= 12 || (sent.meta && sent.analytics)) clearInterval(timer);
    }, 1000);
    document.addEventListener('visitorConsentCollected', send, {once: true});
  }
  initialiseTbbBulkEnquiry();
  document.addEventListener('shopify:section:load', initialiseTbbBulkEnquiry);

  function prefillCorporateGift() {
    const gift = new URLSearchParams(window.location.search).get('gift');
    const form = document.querySelector('#corporate-enquiry form');
    if (!gift || !form) return;
    const field = Array.from(form.elements).find(input => input.name === 'contact[Preferred gift box]');
    if (field && !field.value) field.value = gift.slice(0, 160);
  }
  prefillCorporateGift();
  document.addEventListener('shopify:section:load', prefillCorporateGift);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbb-diwali-range"] && !Shopify.designMode) return;
  try {
    
  function initializeDiwaliRange(root) {
    if (root.dataset.filtersReady) return;
    root.dataset.filtersReady = 'true';
    const controls = root.querySelector('.tbb-diwali__filters');
    const cards = Array.from(root.querySelectorAll('[data-gift-budget]'));
    const count = root.querySelector('[data-gift-count]');
    const empty = root.querySelector('[data-gift-empty]');
    const countTemplate = count.textContent.replace(/\d+/, '{count}');
    const buttons = Array.from(controls.querySelectorAll('button'));
    function filter(budget) {
      let visible = 0;
      cards.forEach(card => {
        card.hidden = budget !== 'all' && card.dataset.giftBudget !== budget;
        if (!card.hidden) visible += 1;
      });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.budget === budget)));
      count.textContent = countTemplate.replace('{count}', String(visible));
      empty.hidden = visible !== 0;
    }
    controls.hidden = false;
    filter('all');
    controls.addEventListener('click', event => {
      const button = event.target.closest('button[data-budget]');
      if (!button) return;
      filter(button.dataset.budget);
      const url = new URL(location.href);
      if (button.dataset.budget === 'all') url.searchParams.delete('budget');
      else url.searchParams.set('budget', button.dataset.budget);
      history.replaceState(null, '', url);
    });
    const initialBudget = new URL(location.href).searchParams.get('budget');
    if (buttons.some(button => button.dataset.budget === initialBudget)) filter(initialBudget);
  }
  document.querySelectorAll('[data-diwali-range]').forEach(initializeDiwaliRange);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-diwali-range]').forEach(initializeDiwaliRange);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbb-gift-collection-grid"] && !Shopify.designMode) return;
  try {
    
  function initializeGiftBrowsers(scope) {
    scope.querySelectorAll('[data-gift-browser]').forEach((browser) => {
      if (browser.dataset.giftInitialized) return;
      browser.dataset.giftInitialized = 'true';
      const controls = browser.querySelector('[data-gift-budget]');
      if (!controls) return;
      const select = controls.querySelector('[data-gift-budget-select]');
      const status = controls.querySelector('[data-gift-results]');
      const cards = Array.from(browser.querySelectorAll('[data-gift-product]'));
      const update = () => {
        const all = select.value === 'all';
        controls.querySelector('.tbb-gift-native__budget-note').hidden = all;
        const [minimum, maximum] = select.value.split(':').map(Number);
        let count = 0;
        cards.forEach((card) => {
          const prices = card.dataset.giftPrices.split(',').filter(Boolean).map(Number);
          const matches = all || prices.some((price) => Number.isFinite(price) && price > minimum && price <= maximum);
          card.hidden = !matches;
          if (matches) count += 1;
        });
        status.textContent = browser.dataset.resultTemplate.replace('[[count]]', String(count));
        const carousel = browser.querySelector('.swiper');
        if (carousel && carousel.swiper) {
          carousel.swiper.update();
          carousel.swiper.slideTo(0, 0);
        }
      };
      select.addEventListener('change', update);
      controls.hidden = false;
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeGiftBrowsers(document));
  } else {
    initializeGiftBrowsers(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeGiftBrowsers(event.target));

  } catch(e) { console.error(e); }
})();
})();
